import {
  ChangeDetectorRef,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
  Input,
  ViewEncapsulation,
} from '@angular/core'
import { AuthService } from '../../services/auth.service'
import { UserProfileService } from '../../services/user-profile.service'
import { InitialPipe } from '../../pipes/initial.pipe'
import { Router, RouterModule } from '@angular/router'
import { CommonModule } from '@angular/common'
import { LoadingService } from '../../services/loading.service'
import { ModalConfig, ModalLandPlatformService } from '@sp401/modal-engine'
import { ConfigService } from 'src/app/services/config.service'
import { NotificationToastComponent } from 'src/app/components/notification-toast/notification-toast.component'

@Component({
  selector: 'fleet-header',
  standalone: true,
  imports: [
    CommonModule,
    InitialPipe,
    RouterModule,
    NotificationToastComponent,
  ],
  encapsulation: ViewEncapsulation.None,
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HeaderComponent {
  cdr = inject(ChangeDetectorRef)

  modalConfig: any = {
    modalId: 'logout_modal',
    type: 'simple',
    dismissible: true,
    title: 'Are you sure you want to logout?',
    level: 'INFO',
    contentConfig: {
      bodyMessage: 'You will log out of the website',
      showDialogControl: {
        submit: true,
        cancel: true,
      },
      label: {
        submitLabel: 'Continue',
        cancelLabel: '',
      },
      submitFunction: () => {
        this.doLogout()
      },
    },
  }

  loadingLogoutModal: ModalConfig = {
    modalId: 'loading_logout_modal',
    type: 'simple',
    dismissible: false,
    title: 'Logging out...',
    level: 'INFO',
    contentConfig: {
      bodyMessage: 'Just few seconds and you will be disconnected',
      showDialogControl: false,
    },
  }

  isLogged: boolean = false
  userProfile: any = {}
  showPanel: boolean = false

  @Input() whiteHeaderUserPanel: boolean = false

  constructor(
    private authService: AuthService,
    private userProfileService: UserProfileService,
    private _modal: ModalLandPlatformService,
    private _loading: LoadingService,
    private router: Router
  ) {
    this.authService.loggedInObservable.subscribe((value: boolean) => {
      this.isLogged = value
      if (this.isLogged && !Object.keys(this.userProfile).length) {
        this.fillUserProfileInformation()
      }
    })
  }

  fillUserProfileInformation(): void {
    this._loading.showLoading()
    this.userProfileService.getProfileData().then((value) => {
      this.userProfile = value.data.profile
      this._loading.hideLoading()
      this.cdr.markForCheck()
    })
  }

  triggerLogout() {
    this._modal.triggerAddModal(this.modalConfig)
  }

  doLogout() {
    this._modal.triggerAddModal(this.loadingLogoutModal)
    this.authService.logout().then(() => {
      this.authService.setIsLogged(false)
      this.router.navigate(['/login'])
    })
  }
}
